import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "selector", "submitter", "planPrice", "planId", "periodId", "servicePlan", "setupFee", "plan", "serviceTypeSelector", "servicePeriodSelector", "servicePeriodButton", "serviceTypeTab", "serviceType", "canCommercial", "canResidential", "addOnModal" ]

  connect() {
    let initialPlanElement = $(this.selectorTarget).find('input:checked')
    this.planElement = initialPlanElement
    this.toggle()
  }

  submitOrShowModal(event) {
    event.preventDefault();
 
    const hasModalAddOns = this.hasAddOnModalTarget && this.addOnModalTarget && this.addOnModalTarget.querySelectorAll('input[type="checkbox"],input[type="radio"]').length > 0;
  
    if (hasModalAddOns) {
      // Show Bootstrap 4 modal using jQuery
      $(this.addOnModalTarget).modal('show');
    } else {
      // No modal add-ons — submit form immediately
      this.submitterTarget.closest("form").submit();
    }
  }
  
  toggle(event) {

    const selectedServiceType = this.serviceTypeSelectorTarget.querySelector("input[type='radio']:checked");
    const selectedServicePeriod = this.servicePeriodSelectorTarget.querySelector("input[type='radio']:checked");
  

    // Remove 'active' class from all buttons in the group
    this.servicePeriodButtonTargets.forEach(button => {
       button.classList.remove("active");
    });

    this.serviceTypeTabTargets.forEach(button => {
      button.classList.remove("active");
    });

    selectedServiceType.closest('label.nav-link').classList.add("active");
    selectedServicePeriod.closest('.btn').classList.add("active");
  
    // // Hide/Show plans based on selected period
    this.planTargets.forEach((plan) => {
       console.log(plan.dataset.period, selectedServicePeriod.value, plan.dataset.type, selectedServiceType.value)
       plan.style.display = (plan.dataset.period === selectedServicePeriod.value && plan.dataset.type === selectedServiceType.value ? "block" : "none")
    });
  }
    
  selectServicePlan(event) {
    let planElement = $(event.target);
    this.planElement = planElement
  }

  get planElement() {
    return this.data.get('selectedPlan')
  }

  set planElement(planElement) {
    console.log(planElement)
    planElement = $(planElement);
    let selectedPlan = planElement.attr('data-service-plan');
    let planPrice    = planElement.attr('data-plan-price');
    let planId       = planElement.attr('data-plan-id');
    let periodId     = planElement.attr('data-period-id');
    let setupFee     = planElement.attr('data-setup-fee');
    let serviceType  = planElement.attr('data-service-type');

    this.data.set('selectedPlan', selectedPlan)
    this.data.set('planPrice',    planPrice)
    this.data.set('planId',       planId)
    this.data.set('setupFee',     setupFee)

    if (selectedPlan) {
      $(this.submitterTarget).removeAttr("disabled")
      $(this.planPriceTarget).val(planPrice)
      $(this.periodIdTarget).val(periodId)
      $(this.planIdTarget).val(planId)
      $(this.setupFeeTarget).val(setupFee)
      $(this.servicePlanTarget).val(selectedPlan)
      $(this.serviceTypeTarget).val(serviceType)
      $(this.canCommercialTarget).val(serviceType=='commercial')
      $(this.canResidentialTarget).val(serviceType=='residential')
    } else {
      $(this.submitterTarget).attr("disabled", true)
    }
  }

  handleChoosePlanClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const input = event.target.closest('label').querySelector('input[type="radio"]')
    input.checked = true;
    console.log(input)
    this.planElement = input;
    input.closest('form').submit();
  }
}
